module.exports = __webpack_public_path__ + "img/unchecked.7324bb48.svg";